import { gsap, Linear } from "gsap";
import { ScrollTrigger } from "gsap/all";
import Swiper, { Navigation, Pagination } from "swiper";

import "swiper/css/bundle";
// swiper core styles
import "swiper/css";
// modules styles
import "swiper/css/navigation";
import "swiper/css/pagination";
import {
  returnBlueprintAnimation,
  returnBorderAnimation,
  returnCoordinateAnimation,
} from "../app";

export default function initHome(isMobile, isTouch, disableScroll = false) {
  if (!document.getElementById("content").querySelector(".home-page")) return;
  var hasExecuted = null;
  var loopedThrough = false;

  var projects = document.querySelectorAll(".home__hero--projects--project");

  new Swiper('.home__hero--projects', {
    slidesPerView: 'auto', 
  })

  if (!isMobile) {
    new Swiper(".home__section--3--desktop--top--slider", {
      modules: [Navigation, Pagination],
      centeredSlides: true,
      slidesPerView: 1,
      loop: true,
      autoplay: {
        delay: 7000,
      },
      pagination: {
        el: ".swiper-pagination",
      },
      navigation: {
        prevEl: ".swiper-button-prev",
        nextEl: ".swiper-button-next",
      },
    });
    new Swiper(".swiper2", {
      modules: [Pagination],
      centeredSlides: true,
      slidesPerView: 1,
      loop: true,
      pagination: {
        el: ".swiper-pagination2",
        clickable: true,
      },
    });
  }

  if (disableScroll) return;

  if (isMobile) {
    document
      .querySelector(".home__footer--link")
      .addEventListener("click", (e) => {
        e.preventDefault();
        gsap.to(window, {
          scrollTo: 0,
        });
      });
    var homeHeroScrub = gsap
      .timeline({
        scrollTrigger: {
          trigger: ".home__hero",
          start: "top top",
          end: "bottom top",
          scrub: true,
        },
      })
      .to(
        ".home__hero--coord span span",
        {
          textContent: function (index, target) {
            return target.dataset.final;
          },
          snap: { textContent: 1 },
        },
        "<"
      );
    var homeHeroLink = gsap.timeline({
      scrollTrigger: {
        trigger: ".home__hero--link",
        start: "top center",
      },
    });
    returnBorderAnimation(homeHeroLink, ".home__hero .link--bordered--border");

    var homeSection1Stagger = gsap
      .timeline({
        scrollTrigger: {
          trigger: ".home__section--1",
          start: "top bottom+=300",
        },
      })
      .from(".home__section--1 h2, .home__section--1 p", {
        autoAlpha: 0,
        xPercent: -10,
        stagger: 0.15,
      });

    var homeSection3 = gsap.timeline({
      scrollTrigger: {
        trigger: ".home__section--3",
        start: "top 25%",
      },
    });
    returnBorderAnimation(
      homeSection3,
      ".home__section--3 .link--bordered--border"
    );
    homeSection3.from(".home__section--3 p", {
      xPercent: -10,
      autoAlpha: 0,
    });

    var homeFooter = gsap.timeline({
      scrollTrigger: {
        trigger: ".home__footer",
        start: "90% bottom",
      },
    });
    returnCoordinateAnimation(homeFooter, ".home__footer .coord");
  } else {
    new Swiper(".home__section--3--desktop--top--slider", {
      modules: [Navigation, Pagination],
      centeredSlides: true,
      slidesPerView: 1,
      loop: true,
      autoplay: {
        delay: 7000,
      },
      pagination: {
        el: ".swiper-pagination",
      },
      navigation: {
        prevEl: ".swiper-button-prev",
        nextEl: ".swiper-button-next",
      },
    });
    new Swiper(".swiper2", {
      modules: [Pagination],
      centeredSlides: true,
      slidesPerView: 1,
      loop: true,
      pagination: {
        el: ".swiper-pagination2",
        clickable: true,
      },
    });    
    if (isTouch) {
      hasExecuted = false;
      var homeHeroScrub = gsap.timeline({
        scrollTrigger: {
          trigger: ".home__hero",
          start: "top top",
          end: "bottom top",
          scrub: true,
        },
      });
      returnCoordinateAnimation(homeHeroScrub, ".home__hero .coord");
      returnBlueprintAnimation(homeHeroScrub, ".home__hero--bp");

      var homeHeroLink = gsap.timeline({
        scrollTrigger: {
          trigger: ".home__hero--link",
          start: "top center",
        },
      });
      returnBorderAnimation(
        homeHeroLink,
        ".home__hero .link--bordered--border"
      );

      var homeSection1Stagger = gsap
        .timeline({
          scrollTrigger: {
            trigger: ".home__section--1",
            start: "top center",
          },
        })
        .from(".home__section--1 h2, .home__section--1 p", {
          autoAlpha: 0,
          xPercent: -10,
          stagger: 0.15,
        });

      var homeSection2Scrub = gsap.timeline({
        scrollTrigger: {
          trigger: ".home__section--2",
          start: "top 75%",
          end: "75% top",
          scrub: true,
        },
      });
      returnCoordinateAnimation(homeSection2Scrub, ".home__section--2--coord");

      var homeSection3Trigger = gsap
        .timeline({
          scrollTrigger: {
            trigger: ".home__section--3--desktop",
            start: "top center",
          },
        })
        .from(".home__section--3--desktop--top--slider", {
          autoAlpha: 0,
          xPercent: -10,
        });
      returnBorderAnimation(
        homeSection3Trigger,
        ".home__section--3--desktop  .link--bordered--border",
        "<50%"
      );
      homeSection3Trigger
        .from(
          ".home__section--3--desktop--bottom",
          {
            yPercent: 10,
            autoAlpha: 0,
          },
          "<50%"
        )
        .from(
          ".home__section--3--desktop p",
          {
            yPercent: 10,
            autoAlpha: 0,
          },
          "<50%"
        );
      returnCoordinateAnimation(
        homeSection3Trigger,
        ".home__section--3--desktop .coord"
      );
    } else {
      //Need to keep track of whether we've looped through the homepage once already
      hasExecuted = false;
      var section3TlPlayed = false;
      var mainScrub = gsap
        .timeline({
          defaults: {
            ease: Linear.easeNone,
          },
          scrollTrigger: {
            trigger: ".home-page",
            start: 0,
            end: "max",
            scrub: true,
            //onLeave and onLeaveBack handle resetting the ST for the infinite scroll
            onLeave: (self) => {
              self.scroll(1);
              ScrollTrigger.update();
              hasExecuted = true;
            },
            onLeaveBack: (self) => {
              if (!hasExecuted) return;
              self.scroll(ScrollTrigger.maxScroll(window) - 1);
              ScrollTrigger.update();
            },
          },
        })
        .to(".home__inner", {
          yPercent: -50,
        });
      returnCoordinateAnimation(mainScrub, ".home__hero .coord", "<");
      returnBlueprintAnimation(mainScrub, ".home__hero--bp");
      mainScrub.to(".home__inner", {
        xPercent: -50,
      });
      returnBlueprintAnimation(mainScrub, ".home__section--2--bp");
      mainScrub
        .set(".home__hero .coord--line", {
          clearProps: "all",
        })
        .set(".home__hero .coord svg path, .home__hero--bp .draw-on-scroll", {
          drawSVG: "0%",
        })
        .set(".home__hero .coord span span", {
          textContent: function (index, target) {
            return target.dataset.original;
          },
        })
        .to(".home__inner", {
          yPercent: 0,
          onUpdate: function () {
            if (this.progress() > 0.75 && !section3TlPlayed) {
              section3TlPlayed = true;
              homeSection3Trigger.play();
            }
          },
        });
      returnBlueprintAnimation(mainScrub, ".home__section--3--desktop--bp");
      returnCoordinateAnimation(
        mainScrub,
        ".home__section--3--desktop .coord",
        "<"
      );
      mainScrub.to(".home__inner", {
        xPercent: 0,
      });
      var homeHeroLink = gsap.timeline({
        scrollTrigger: {
          trigger: ".home__hero--link",
          start: "top center",
        },
      });
      returnBorderAnimation(
        homeHeroLink,
        ".home__hero .link--bordered--border"
      );
      var homeSection1Stagger = gsap
        .timeline({
          scrollTrigger: {
            trigger: ".home__section--1",
            start: "top 25%",
          },
        })
        .from(".home__section--1 h2, .home__section--1 p", {
          autoAlpha: 0,
          xPercent: -10,
          stagger: 0.15,
        });
      var homeSection3Trigger = gsap.timeline({
        paused: true,
      });
      returnBorderAnimation(
        homeSection3Trigger,
        ".home__section--3--desktop .link--bordered--border"
      );
      homeSection3Trigger
        .from(
          ".home__section--3--desktop--bottom",
          {
            yPercent: 10,
            autoAlpha: 0,
          },
          "<50%"
        )
        .from(
          ".home__section--3--desktop p",
          {
            yPercent: 10,
            autoAlpha: 0,
          },
          "<50%"
        )
        .from(
          ".home__section--3--desktop--top--slider",
          {
            autoAlpha: 0,
            xPercent: -10,
            stagger: 0.15,
          },
          "<50%"
        );
    }
  }
}
